import { render, staticRenderFns } from "./DocumentsCell.vue?vue&type=template&id=3385a792&scoped=true"
import script from "./DocumentsCell.vue?vue&type=script&lang=js"
export * from "./DocumentsCell.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCell.vue?vue&type=style&index=0&id=3385a792&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3385a792",
  null
  
)

export default component.exports